import {get, post} from '@/services/infrastructure/api.service'
import {padStart, uniq} from 'lodash'
import {SummaryReportData} from '@/types/reports/Report'
import {TransactionSearchParams} from '@/types/transaction/TransactionSearchParams'
import {ReportMeta} from '@/types/ReportMeta'
import {BalanceReport} from '@/balrep/BalanceReport'
import {ProfLosReport} from '@/proflos/ProfLosReport'

const PATH_BALANCE = '/reports/balance-report'
const PATH_TRIAL_BALANCE_CSV = '/reports/trial-balance-csv'
const GENERAL_LEDGER_CSV = '/transactions/-/transaction-lines.csv'
const TRANSACTION_JOURNAL_CSV = '/transactions/-/transaction-journal.csv'
const PATH_PROFLOS = '/reports/profit-and-loss-report'


const fetchBalanceReport = async (fromDate: string, toDate: string, department: string | undefined, project: string | undefined): Promise<BalanceReport | undefined> => {
    const reportData = await get<SummaryReportData>(PATH_BALANCE, {
        fromDate,
        toDate,
        department,
        project
    })

    return reportData && new BalanceReport(reportData)
}

const createTrialBalanceCSVExport = (fromDate: string, toDate: string, department: string | undefined, project: string | undefined) => {
    return post(PATH_TRIAL_BALANCE_CSV, {}, {}, {
        fromDate: fromDate,
        toDate: toDate,
        department,
        project
    })
}

const createGeneralLedgerCSVExport = (params: TransactionSearchParams): Promise<ReportMeta> => {
    return post(GENERAL_LEDGER_CSV, {}, {}, {...params})
}

const createTransactionJournalCSVExport = (params: TransactionSearchParams): Promise<ReportMeta> => {
    return post(TRANSACTION_JOURNAL_CSV, {}, {}, {...params})
}

const fetchProfitAndLossReport = async (fromDate: string, toDate: string, department?: string | undefined, project?: string | undefined): Promise<ProfLosReport | undefined> => {
    const data = await get<SummaryReportData>(PATH_PROFLOS, {
        fromDate,
        toDate,
        department,
        project
    })
    //TODO: Error handling specific to summaryReport
    return data && new ProfLosReport(data)
}

const getMonthIntervals = (fromDate: string, toDate: string) => {
    const months = []
    const iteree = new Date(fromDate)
    const endDate = new Date(toDate)
    while (iteree <= endDate) {
        months.push(
            iteree.getFullYear()
            + '-'
            + padStart((iteree.getMonth() + 1).toString(), 2, '0')
        )
        iteree.setDate(iteree.getDate() + 1)
    }
    return uniq(months)
}

export {
    fetchBalanceReport,
    fetchProfitAndLossReport,
    getMonthIntervals,
    createTrialBalanceCSVExport,
    createGeneralLedgerCSVExport,
    createTransactionJournalCSVExport
}